import gql from "graphql-tag";


export const GET_AGREEMENT = gql`    
query Setting($name: String!){
 Setting(where: {name: {_eq: $name}}){      
      value
 }
}
`